import { Injectable } from '@angular/core';
import { Customer } from '../models/customer.model';
import  { HttpClient } from '@angular/common/http';
//import { NgForm } from '@angular/forms';
//import{ GlobalConstants } from '../../common/global-constants';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { resolveSanitizationFn } from '@angular/compiler/src/render3/view/template';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {
 // readonly BaseURI = GlobalConstants.apiURL;
  BaseURI : string;
  formData : Customer;
  list : Customer[];
 //list : Array<Customer>;
 //list : AngularFireList<any>;


  form: FormGroup = new FormGroup({
    sno: new FormControl(null),
    region :  new FormControl('', Validators.required),
    firstname: new FormControl('', Validators.required),
    lastname: new FormControl('', Validators.required),
    emailid: new FormControl('', Validators.email),
    phoneno: new FormControl('', [Validators.required, Validators.minLength(8)]),
    status: new FormControl(''),
    company: new FormControl(''),
    activatonno: new FormControl(''),
    country :  new FormControl(''),
    note :  new FormControl(''),
    newsletter :  new FormControl(''),
    software :  new FormControl(''),
    password :  new FormControl(''),
    followup : new FormControl(''),
    reminder : new FormControl(''),
    assignedto : new FormControl(''),
    createdon : new FormControl(''),
    modifiedon : new FormControl(''),
    createdby : new FormControl(''),
    modifiedby : new FormControl(''),
    clabel : new FormControl('')
  });


  constructor(private http : HttpClient) {
    console.log("constructor : CustomerService ");
    this.BaseURI = window.location.origin + "/api";
  }

  populateForm(customer) {
   // this.form.setValue(_.omit(employee,'departmentName'));
   this.form.setValue(customer);
  }


 // postCustomerDetail(form : Customer)
  postCustomerDetail()
  {
     return this.http.post(this.BaseURI + "/Customers", this.formData);
  }

  putCustomerDetail()
  {
     return this.http.put(this.BaseURI + "/Customers/" + this.formData.sno, this.formData);
  }

  refreshList()
  {

    return this.http.get(this.BaseURI + "/Customers").toPromise().then(
      res => {
        this.list = res as Customer[];

      }
    );
  }

  getCustomerList()
  {
     return this.http.get(this.BaseURI + "/Customers");
   // this.list = this.http.get(this.BaseURI + "/Customers");
    //return this.list.snapshotChanges();


  }

  insertCustomer(customer) {
    return this.http.post(this.BaseURI + "/Customers", customer);
  }

  updateCustomer(customer) {
    return this.http.put(this.BaseURI + "/Customers/" + customer.sno, customer);
  }
/*
  updateEmployee(employee) {
    this.employeeList.update(employee.$key,
      {
        fullName: employee.fullName,
        email: employee.email,
        mobile: employee.mobile,
        city: employee.city,
        gender: employee.gender,
        department: employee.department,
         hireDate: employee.hireDate == "" ? "" : this.datePipe.transform(employee.hireDate, 'yyyy-MM-dd'),
        isPermanent: employee.isPermanent
      });
  }*/

  deleteCustomerDetail(sno)
  {
    return this.http.delete(this.BaseURI + "/Customers/" + sno);

  }

  findCustomerList(searchStr)
  {
    return this.http.get(this.BaseURI + "/Customers/Find?keywords=" + searchStr);
  }

  initializeFormGroup(){

    this.form.setValue({
      sno : 0,
      region :  null,
      firstname :  null,
      lastname :  null,
      phoneno :  null,
      emailid :  null,
      country :  null,
      note :  null,
      newsletter :  null,
      software :  null,
      password :  null,
      followup : null,
      reminder : null,
      activatonno : null,
      status : null,
      assignedto : null,
      createdon : null,
      modifiedon : null,
      createdby : null,
      modifiedby : null,
      company : null,
      clabel : null,
    });
  /*
    this.formData = {
      sno : 0,
      region :  null,
      firstname :  null,
      lastname :  null,
      phoneno :  null,
      emailid :  null,
      country :  null,
      note :  null,
      newsletter :  null,
      software :  null,
      password :  null,
      followup : null,
      reminder : null,
      activatonno : null,
      status : null,
      assignedto : null,
      createdon : null,
      modifiedon : null,
      createdby : null,
      modifiedby : null,
      company : null,
      clabel : null,
    }*/
  }



}
